import { jwtDecode } from "jwt-decode";

let auth0Client = null;
let cachedToken = null;
let cachedTokenExpiry = null;

function waitForAuth0Client(timeout = 2000, intervalTime = 50) {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();
    const checkClient = () => {
      if (auth0Client) {
        resolve();
      } else if (Date.now() - startTime >= timeout) {
        reject(new Error("Timed out waiting for Auth0 client to initialize."));
      } else {
        setTimeout(checkClient, intervalTime);
      }
    };
    checkClient();
  });
}

export function setAuth0Client(client) {
  auth0Client = client;
  cachedToken = null;
  cachedTokenExpiry = null;
}

export async function getBearerToken() {
  if (!auth0Client) {
    try {
      await waitForAuth0Client();
    } catch (e) {
      throw new Error("Auth0 client is not initialized.");
    }
  }

  const now = Date.now() / 1000; // current time in seconds

  if (cachedToken && cachedTokenExpiry && (cachedTokenExpiry > now + 120)) {
    return cachedToken;
  }

  const token = await auth0Client.getTokenSilently();

  let decoded;
  try {
    decoded = jwtDecode(token);
    cachedToken = token;
    cachedTokenExpiry = decoded.exp;
  } catch (error) {
    console.warn("Failed to decode JWT token", error);
    cachedToken = token;
    cachedTokenExpiry = now + 60;
  }

  if (decoded.iat && decoded.iat > now) {
    const waitTime = (decoded.iat - now) * 1000;
    console.info(`Token not yet valid, waiting ${waitTime} ms for "iat" to pass.`);
    await new Promise((resolve) => setTimeout(resolve, waitTime));
  }

  return token;
}